import type { MeContext, PortfolioNode } from '@vizit/api';

export function findPortfolioById(context: MeContext, portfolioId: string | null): PortfolioNode | undefined {
  if (!portfolioId) {
    return undefined;
  }

  return context.organization.portfolios.find((portfolio) => portfolio.id === portfolioId);
}
